import React, { Component } from 'react';
import { Card, CardBody, Collapse } from 'reactstrap';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { UIToggleBoolean } from '../PropertyActions';

export function formatCurrency(value, addNegativeSymbol, addPositiveSymbol) {
    var val = Math.floor(value);
    var formattedNumber = Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(val);
    formattedNumber = formattedNumber.replace('-', ''); //We'll add our own negative symbol

    if (addPositiveSymbol && value > 0) {
        return <span className='currency currency-positive'><span className='currency-prefix'>+</span>{formattedNumber}</span>;
    }
    else if (addNegativeSymbol && value < 0) {
        return <span className='currency currency-negative'><span className='currency-prefix'>-</span>{formattedNumber}</span>;
    }
    else {
        return formattedNumber;
    }

}

export class ResultsPanel extends Component {
    render() {
        const childrenWithProps = React.Children.map(this.props.children, child =>
            React.cloneElement(child, { name: this.props.name, isOpen: this.props.isOpen })
        );

        return (
            <div className="results-panel">
                {childrenWithProps}
            </div>
        );
    }
}

class ResultsPanelTitle extends Component {
    constructor(props) {
        super(props);
        this.handleRowToggle = this.handleRowToggle.bind(this);
    }

    handleRowToggle(event) {
        event.persist();
        console.log(event);
        // dispatches actions to update value
        this.props.UIToggleBoolean(this.props.name);
    }

    

    render() {
        var value = this.props.value;

        if (this.props.format !== 'none') {
            value = formatCurrency(this.props.value, this.props.addNegativeSymbol, this.props.addPositiveSymbol);
        }

        return (
            <div data-testid={this.props.testId} onClick={this.handleRowToggle} className={'results-panel-row expandable'}>
                <div className=''>{this.props.isOpen ? <FontAwesomeIcon icon={faChevronDown} /> : <FontAwesomeIcon icon={faChevronRight} />}</div>
                <div className=''>{this.props.title}</div>
                <div className=''>{value}{(this.props.suffix ? this.props.suffix : '')}</div>
            </div>
        );
    }
}

export class ResultsPanelBody extends Component {
    render() {
        return (
            <Collapse isOpen={this.props.isOpen}>
                {this.props.children}
            </Collapse>
        );
    }
}

export class ResultsPanelRow extends Component {
    render() {
        var value = this.props.value;

        if (this.props.format !== 'none') {
            value = formatCurrency(this.props.value, this.props.addNegativeSymbol, this.props.addPositiveSymbol);
        }

        return (
            <div className={'results-panel-row'}>
                <div className=''></div>
                <div className=''>{this.props.title}</div>
                <div className=''>{value}{(this.props.suffix ? this.props.suffix : '')}</div>
            </div>
        );
    }
}

export class ResultsPanelRowText extends Component {
    render() {
        return (
            <div className={'results-panel-row text'}>
                {this.props.children}
            </div>
        );
    }
}

export class ResultsPanelKPIRow extends Component {
      render() {
          var value = this.props.value;

          if (this.props.format !== 'none') {
              value = formatCurrency(this.props.value, this.props.addNegativeSymbol, this.props.addPositiveSymbol);
          }

        return (
            <div className={'results-panel-row'}>
                <div className=''></div>
                <div className=''>
                    {this.props.title}
                    <span className='kpi'>{this.props.kpi}</span>
                </div>
                <div className=''>{value}{(this.props.suffix ? this.props.suffix : '')}</div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return state.property;
};

export default connect(
    mapStateToProps,
    { UIToggleBoolean }
)(ResultsPanelTitle);


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/ResultsPanel.jsx